export default class SukuAfterpay extends HTMLElement {
  static get observedAttributes() {
    return ['total', 'installment']
  }

  constructor() {
    super()

    this.variants = this.getAttribute('variants').split(',')
    this.total = this.getAttribute('total')
    this.installment = this.getAttribute('installment')

    this.price = this.querySelector('span[data-afterpay-price]')

    this.className = 'pt-6 pb-10 block'

    this.urlWatch.bind(this)
  }

  handleURLChange() {
    const variant = window.location.href.split('variant=')[1]

    const selected = this.variants.find(item => {
      return item.split('|')[0] === variant
    })

    const total = selected.split('|')[1]
    const installment = Math.ceil((total / 4))

    this.setAttribute('total', total)
    this.setAttribute('installment', installment)

    this.price.textContent = `$${installment}`
  }

  urlWatch() {
    let previous = window.location.href

    this.interval = setInterval(() => {
      const current = window.location.href 

      if (previous !== current) {
        previous = current

        this.handleURLChange()
      }
    }, 250)
  }

  connectedCallback() {
    this.urlWatch()
  }

  disconnectedCallback() {
    window.clearInterval(this.interval)
  }

  attributeChangedCallback(name, current, value) {
    if (current === value) {
      return
    }

    switch (name) {
      case 'total' :
        this.total

        break
      case 'installment' :
        this.installment = value

        break
    }
  }
}

customElements.define('suku-afterpay', SukuAfterpay)
